import { render, staticRenderFns } from "./MatrixLanguage.vue?vue&type=template&id=8ca543aa&scoped=true&"
import script from "./MatrixLanguage.vue?vue&type=script&lang=js&"
export * from "./MatrixLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca543aa",
  null
  
)

export default component.exports